import { ranks } from '../constants';
const pubSub = require("../pubsub");
export { default as UserStorage } from './backend';

// helper method for converting query fields into part of URL
function _prepareUrl(path, query) {
    let url = new URL(window.location.origin + path);
    url.search = new URLSearchParams(query);
    return url;
}

// handles storage of map/geographic information
export class MapStorage {

    // Fetch data for a particular zipcode, fires when tooltip is shown for a zipcode
    fetchZipcodeData(feature, fields, callback) {
        let url = _prepareUrl('/tooltip/zip/' + feature.properties.ZCTA5CE10, fields);

        fetch(url).then((response) => {
            if (!response.ok) { throw response.statusText }
            response.json().then(data => {
                console.log(data)
                let title = feature.properties.ZCTA5CE10;
                if (data.city) {
                    // city name(s) available
                    title = `${data.city} (${title})`;
                } else if (data.county) {
                    // only county available
                    title = `${data.county} County (${title})`;
                } else {
                    // neither available
                    title = `??? (${title})`;
                }
                callback({
                    ...data,
                    title: title
                });
            });
        }).catch(error => {
            pubSub.publish('notify:load:stop');
            pubSub.publish('notify:error', error);
        });
    }

    // Fetch zipcode ranks for all of US, this fires when computing ranks for all of US.
    fetchUsRanks(query) {
        console.log('fetching us', query);
        let url = _prepareUrl('/rank/us', query);

        return new Promise((resolve, reject) => {
            fetch(url).then(response => {
                if (!response.ok) { throw response.statusText }
                response.json().then(data => {
                    resolve(data);
                    pubSub.publish('ranks:country', data);
                });
            }).catch(error => {
                reject(error);
            });
        });
    }

    // Fetch zipcode ranks for individual state, this fires when zooming into state view.
    // Also fires when recomputing ranks while zoomed in.
    fetchStateRanks(state, query) {
        return new Promise((resolve, reject) => {
            if (!Object.keys(query).length) {
                // no ranks selected
                resolve({ 1:[], 2:[], 3:[], 4:[], 5:[], 6:[], 7:[], 8:[], 9:[], 10:[] });
            } else {
                let url = _prepareUrl('/rank/state/' + state, query);

                fetch(url).then(response => {
                    if (!response.ok) { throw response.statusText }
                    response.json().then(data => {
                        if (data.message) {
                            pubSub.publish('notify:info', data.message);
                        }
                        resolve(data.ranks);
                        pubSub.publish('ranks:state', data);
                    });
                }).catch(error => {
                    reject(error);
                });
            }
        });
    }
}
